import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_8381_1856)\"><path d=\"M19 10V16C19 17.6569 17.6569 19 16 19H4C2.34315 19 1 17.6569 1 16V10\" stroke=\"white\" stroke-width=\"2\"></path><path d=\"M4 6L10 1L16 6\" stroke=\"white\" stroke-width=\"2\" stroke-linejoin=\"round\"></path><path d=\"M10 2V5.5V15\" stroke=\"white\" stroke-width=\"2\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_8381_1856\"><rect width=\"20\" height=\"20\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }